export default {
    'admin': 'Администратор',
    'mechanic': 'Механик',
    'client': 'Клиент',
    'consultant': 'Консультант',
}
